// A drillhole's derived figures, served by GET api/projects/summaries?project=
// (Services/DrillholeSummaryStore.cs) and kept out of map.json so the map does
// not grow. The server builds them from the survey bodies; this module only
// reads them. A hole with no summary has no figures yet - render it as it was.

// The customer's own metadata column names, which the CSV import stores
// verbatim, so the keywords stay English in every language. First key that
// *contains* the keyword wins, which is how the planned trajectory has always
// been found; keep any new metadata key clear of "depth", "azimuth" and "dip".
export const getMetadataValue = (metadata, keyword) => {
    if (!metadata) return null;
    const item = metadata.find(m => m.key?.toLowerCase().includes(keyword.toLowerCase()));
    return item ? parseFloat(item.value) : null;
};

export const plannedDepth = (metadata) => {
    const depth = getMetadataValue(metadata, 'depth');
    return depth != null && Number.isFinite(depth) && depth > 0 ? depth : null;
};

export const hasCoreTrakRuns = (summary) => (summary?.coreTrakRuns || 0) > 0;

// At most one decimal, and none when it is whole ("48", "5.6"), with a full
// stop in every language. Deliberately unitless: the app does not know whether
// a customer works in metres or feet, and a planned depth typed into metadata
// is in whichever they use.
export const formatDepth = (value) =>
    value == null || !Number.isFinite(value) ? null : String(Math.round(value * 10) / 10);

// "48/54": deepest approved shot, then the planned depth when one is recorded.
// Null when nothing has been surveyed - a planned depth alone is not a depth.
// The planned half is read from the map rather than stored with the summary,
// so an Info-tab edit shows at once.
export const depthAgainstPlan = (summary, metadata) => {
    const bottom = formatDepth(summary?.bottom);
    if (bottom == null) return null;
    const planned = formatDepth(plannedDepth(metadata));
    return planned == null ? bottom : `${bottom}/${planned}`;
};

// Changes only when a hole is added, removed or gains or loses a survey, so
// summaries are re-fetched when membership changes and not on every map
// update (a metadata edit, a completion toggle).
export const membershipSignature = (project) =>
    (project?.drillholes || [])
        .map(d => `${d.name}:${(d.surveys || []).map(s => s.fileId).join(',')}`)
        .join('|');
